import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './HeartIcon.module.scss';

const HeartIcon = ({ backgroundColor, isHeartFilled, tag }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="HeartIcon"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.heart]: true,
        [CN.dark]: isDarkMode,
        [CN.requestedStylist]: isHeartFilled,
      })}
      style={{
        backgroundColor,
      }}
    ></div>
  );
};

export default HeartIcon;
